import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#082018] text-[#F5EFE0] pt-16 pb-8 tc-grain">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-3 gap-10 pb-10 border-b border-[#C9A361]/20">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-14 h-14 rounded-sm border border-[#C9A361]/50 flex items-center justify-center bg-[#0F3527]">
                <span className="font-cinzel text-[#C9A361] text-xl">TC</span>
              </div>
              <div>
                <p className="font-cinzel text-[10px] tracking-[0.25em] text-[#F5EFE0]/70">AGROPECUARIA</p>
                <p className="font-cormorant text-[#F5EFE0] text-2xl leading-none mt-0.5">Tres Cerritos</p>
              </div>
            </div>
            <p className="font-cormorant italic text-[#C9A361] text-xl">
              Aprender. Descubrir. Mejorar. Compartir.
            </p>
          </div>

          <div>
            <p className="font-cinzel text-[#C9A361] text-xs tracking-[0.3em] mb-4">CONTACTO</p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#C9A361] mt-0.5" />
                <span>Higuerillas de Abangares, Guanacaste, Costa Rica</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-[#C9A361]" />
                <a href="mailto:info@trescerritos.com" className="hover:text-[#C9A361]">info@trescerritos.com</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-[#C9A361]" />
                <a href="tel:+50670894810" className="hover:text-[#C9A361]">+506 7089 4810</a>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-cinzel text-[#C9A361] text-xs tracking-[0.3em] mb-4">SÍGUENOS</p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 rounded-full border border-[#C9A361]/40 flex items-center justify-center hover:bg-[#C9A361] hover:text-[#082018] transition-colors">
                <Facebook size={16} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-[#C9A361]/40 flex items-center justify-center hover:bg-[#C9A361] hover:text-[#082018] transition-colors">
                <Instagram size={16} />
              </a>
            </div>
          </div>
        </div>

        <p className="text-center font-cinzel text-[11px] tracking-[0.25em] text-[#F5EFE0]/60 mt-8">
          GENÉTICA, TECNOLOGÍA Y CONOCIMIENTO PARA LAS PRÓXIMAS GENERACIONES
        </p>
        <p className="text-center text-xs text-[#F5EFE0]/40 mt-3">
          © {new Date().getFullYear()} Agropecuaria Tres Cerritos. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}
